import { render, staticRenderFns } from "./UmppCreate.vue?vue&type=template&id=7c17e89d&"
import script from "./UmppCreate.vue?vue&type=script&lang=js&"
export * from "./UmppCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports